import React, { useEffect, useState, useRef, useContext } from 'react';
import { 
    Row,
    Col,
} from 'react-bootstrap';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faSearch,
  faPlus,
  faMoneyBill,
  faEraser,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import DataTable from 'react-data-table-component';
import table from './facturacion.table';
import utils from '../../utils/utils.functions';
import ClienteComponentModal from '../../components/clientesmodal.component';
import ProductSearchModal from '../../components/productos/products.component';
import { ConfigContext } from '../../context/config.context';
import notification from '../../components/notification.component';
import ConfirmaBoleta from './facturacion.modal';
import functions from './facturacion.functions';
import { ConfigContextUtils } from '../../context/contextUtils.context';
import { useHistory } from 'react-router';
import paquetesFunction from '../paquetes/paquetes.functions';
import { v4 as uuidv4 } from 'uuid';
import DocumentSalesType from './doument_sales/documentTypeSales.component';
import ConfirmAlertV2 from '../../components/confirmv2.component';

const INITIAL_COMERCIAL_DOCUMENT = 'VN';

const FacturacionComponent = ({ 
    dataClient = null,
    isGuide = false,
    btnClose = false, 
    onClose = () => {}, 
    dataFullGuide = null, 
    isReserved= false, 
    refresh = () => {},
    dataReserverGuide = null,
    fromOrigin = 'sales',
}) => {

    const history = useHistory();
    const { setPreloader } = useContext(ConfigContextUtils);
    const { config } = useContext(ConfigContext);   
    const productsInputs = useRef([]);
    const pagosInputs = useRef([]);
    const [subtotal, setSubTotal] = useState(0);
    const [modalcliente, setModalCliente] = useState(false);
    const [cliente, setCliente] = useState(dataClient);
    const [modalproducto, setModalProducto] = useState(false);
    const [producto, setProducto] = useState(null);
    const [cantidad, setCantidad] = useState(0);
    const [tipospago, setPagos] = useState([]);
    const [pagos, setPagosInput] = useState([]);
    const [pIndex, setIndex] = useState('null');
    const [recibido, setRecibido] = useState(0);
    const [confirma, setConfirma] = useState(false);
    const [documentTypeReference, setDocumentTypeReference] = useState(null);
    const [typeDocument, setTypeDocument] = useState(INITIAL_COMERCIAL_DOCUMENT);
    const [confirmSameClient, setConfirmSameClient] = useState(false);

    const [data, setData] = useState([]);

    useEffect(() => {
        if (dataReserverGuide && isReserved) {
            setDocumentTypeReference(dataReserverGuide);
            setTypeDocument('ND');
        }
    },[dataReserverGuide])

    useEffect(() => {
        setCliente(dataClient);
    },[dataClient])

    useEffect(() => {
        let total = pagos.reduce((a, { monto }) => { return  a + monto }, 0);
        setRecibido(total);
    },[pagos]);

    useEffect(() => {
        if (documentTypeReference && !isReserved) {
            setConfirmSameClient(!confirmSameClient);
        }
    },[documentTypeReference]);

    const confirmSameClientAction = () => {
        setCliente(documentTypeReference.boleta_cliente);
        setConfirmSameClient(!confirmSameClient);
    }
    
    const agregarmontopagos = (event, row, alphanumeric, field) => {

        if (!alphanumeric) {
            utils.onlyNumber(event);
        }
        
        if (event.key === undefined || event.key === 'Enter') {
            const updateData = [...pagos];
            const index = updateData.findIndex(val => val.uuid === row.uuid);
            if (index !== -1) {
                const updateValue = [...pagos];
                let value = event.target.value === '' ? updateData[index][field] : event.target.value;
                updateData[index][field] = alphanumeric ? value : parseInt(value);
                pagosInputs.current[row.uuid].blur();
                setPagosInput(updateValue);
            }
        }
    }

    const agregarpagos = () => {

        if (pIndex === 'null') {
            notification.warning('Debe seleccionar un metodo de pago');
            return false;
        }

        const element = tipospago[pIndex];
        const updateValue = [...pagos];
        
        updateValue.push({ 
            ...element,
            monto: 0,
            referencia_pago: 0,
            uuid: uuidv4()
        });

        setPagosInput(updateValue);

    }

    const removertipopago = (uuid) => {
        const updateValue = [...pagos];
        const index = updateValue.findIndex(val => val.uuid === uuid);
        updateValue.splice(index, 1);
        setPagosInput(updateValue);
    }

    const cantidadproducto = (event) => {
        setCantidad(event.target.value)
    }

    useEffect(() => {
        utils.formasPago().then((response) => {
            setPagos(response.tipoPagos);
        });
    },[]);

    useEffect(() => {
        const subTotalCalculate = () => {
            const value = data.reduce(function (a, { subtotal }) { return a + subtotal }, 0);
            setSubTotal(value);
        }
        subTotalCalculate();

        if (!data.length) {
            setPagosInput([]);
        }
    },[data]);

    const changePriceColumn = (event, values) => {
        
        utils.onlyNumber(event);

        if (event.key === undefined || event.key === 'Enter') {
            const updateData = [...data];
            const index = updateData.findIndex(val => val.id === values.id);
            if (index !== -1) {
                let value = event.target.value === '' ? updateData[index].precio_original : event.target.value;
                updateData[index].precio = parseInt(value);
                updateData[index].subtotal = parseInt(value) * updateData[index].cantidad;
                updateData[index].editado = true;
                productsInputs.current[values.id].blur();
            }
            setData(updateData);
        }
    }

    const removeItems = (item) => {
        const updateData = [...data];
        const index = updateData.findIndex(val => val.id === item.id);
        if (index !== -1) {
            updateData.splice(index, 1);
            setData(updateData);
        }
    }

    const clienteseleccionado = (item) => {
        setCliente(item);
        setModalCliente(false);
    }

    const addValidProductGuide = (item) => {

        const hasGuide = data.filter(val => val.is_guide === true || val.is_reserve === true);

        if (hasGuide.length) {
            notification.warning('Solo se puede agregar un producto de tipo GUIA o RESERVA');
            return false;
        }

        const updateData = [...data];
        const formatValue = { 
            id: item.id,
            descripcion_productos: item.nombre_producto,
            cantidad: 1,
            precio: item.costo,
            precio_original: item.costo,
            subtotal: parseInt(cantidad) * parseInt(item.costo),
            editado: false,
            remove: true,
            is_reserve: item.is_reserve,
            is_guide: item.is_guide,
         };

         updateData.push(formatValue);
         setData(updateData);
         setProducto(null);
         setCantidad(0);
         setModalProducto(false);
    }

    const productoseleccionado = (item) => {
        if (item.is_guide || item.is_reserve) {
            addValidProductGuide(item);
        } else {
            setProducto(item);
            setModalProducto(false);
        }
    }

    const removercliente = () => {
        setCliente(null);
    }

    const agregarProducto = () => {

        if (cantidad === '' || cantidad === 0) {
            notification.warning('La cantidad no puede ser (0)')
            return false;
        }

        if (!producto) {
            notification.warning('Debe seleccionar un producto')
            return false;
        }

       const updateData = [...data];

       const existeproducto = updateData.findIndex(val => val.id === producto.id);

       if (existeproducto >= 0) {
            
             const changeCantidad = parseInt(updateData[existeproducto].cantidad) + parseInt(cantidad);
             updateData[existeproducto].cantidad = changeCantidad;
             updateData[existeproducto].subtotal = parseInt(changeCantidad) * parseInt(updateData[existeproducto].precio);

       } else {

        const formatValue = { 
                id: producto.id,
                descripcion_productos: producto.nombre_producto,
                cantidad: cantidad,
                precio: producto.costo,
                precio_original: producto.costo,
                subtotal: parseInt(cantidad) * parseInt(producto.costo),
                editado: false,
                remove: true,
                is_guide: producto.is_guide,
            };

            updateData.push(formatValue);    

        }

        setData(updateData);
        setProducto(null);
        setCantidad(0);
    }

    const validarinformacion = () => {
        if (!cliente) {
            notification.warning('Debe seleccionar un cliente');
            return false;
        }

        if (!data.length) {
            notification.warning('No existen productos asociados al recibo');
            return false;
        }

        if (isGuide) {
            let guideProductShow = false;
            data.forEach(item => {  
                if (item.is_guide || item.is_reserve) {
                    guideProductShow = true;
                }
            });

            if (!guideProductShow) {
                notification.warning('Debe agregar un producto GUIA o RESERVA para completar el pago');
                return false;
            }
        }

        if (!pagos.length) {
            notification.warning('Debe asociar un metodo de pago al recibo');
            return false;
        }

        if (recibido !== subtotal) {
            notification.warning('El monto recibido es diferente al monto a pagar');
            return false;
        }

        if (!validReferenciaPagos(pagos)) {
            notification.warning('Existe un metodo de pago sin referencia agregada');
            return false;
        }

        if (isGuide && !dataFullGuide) {
            notification.warning('Existe un problema con los datos de la guia asociada');
            return false;
        }

        if (typeDocument !== 'VN' && !documentTypeReference) {
            const nameDocument = utils.getTypeDocumentName(typeDocument);
            notification.warning(`Debe asociar el tipo de documento ${nameDocument} a un recibo anterior.`);
            return false;
        }

        setConfirma(true);
    }

    const validReferenciaPagos = (validPagos) => {
        let passed = true;
        validPagos.forEach(item => {
            if (item.referencia && (item.referencia_pago === "" || !item.referencia_pago)) {
                passed = false;
            }
        });

        return passed;
    }

    const completarRegistroFacturacion = (values) => {

       setPreloader(true);
       const isReserve = data.filter(item => item.is_reserve === true);

       let payload = {
            cliente_id: cliente.id,
            fecha: moment().format('YYYY-MM-DD'),
            hora: moment().format('HH:mm'),
            monto_total: subtotal,
            ...values,
            productos: generarpayloadproduct(data),
            formas_pago: generarpayloadpagos(pagos),
            is_guide: isGuide,
            ...(isGuide && { data_full_guide: {...dataFullGuide, modEspera: isReserve.length ? true : false } }),
            type_document: typeDocument,
            document_type_reference: documentTypeReference,
            fromOrigin,
       }

       if (isGuide) {
          paquetesFunction.registrarGuia(payload).then((response) => {
            if (response.status === 200) {
              if (response.data.registro_guia) {
                if (!isReserved) {
                    history.replace(`/detalle/${response.data.uuid}`);
                } else {
                    refresh();
                    onClose();
                }
              } else {
                notification.warning('Revise la información existe un problema con los datos');
              }
            }
          })
       } else {
            functions.registrar(payload).then((response) => {
                if (response.registro_boleta) {
                    notification.success();
                    setConfirma(!confirma);
                    history.push(`/boletas/listado/${response.boleta_id}`);
                } else {
                    notification.warning('Ocurrio un error con el registro.');
                }
                setPreloader(false);
        });
       }
    }


    const closeCofirmar = () => {
        setConfirma(!confirma);
    }

    const completedataconfirm = (values) => {
        completarRegistroFacturacion(values);
        closeCofirmar();
    }

    const generarpayloadpagos = (pagosSeleccionados) => {

        const nuevosPagos = pagosSeleccionados.map(item => {
            return {
                forma_pago: item.id,
                monto: item.monto,
                referencia: item.referencia_pago,
            }
        });

        return nuevosPagos;
    }

    const generarpayloadproduct = (productosSeleccionados) => {

        const nuevosValores = productosSeleccionados.map(item => {

            return {
                producto_id: item.id,
                cantidad: parseInt(item.cantidad),
                precio_original: item.precio_original,
                precio_modificado: item.precio,
                observacion: "",
                referencia: "",
                is_guide: item.is_guide, 
            }
        });


        return nuevosValores;
    }

    const mensajedinerorestante = () => {
        if (pagos.length) { 
            if (recibido < subtotal) {
                return <small>Faltan: {utils.formatMoney(subtotal - recibido)}</small>
            } else if (recibido > subtotal) {
                return <small>Excedido por: {utils.formatMoney(recibido - subtotal)}</small>
            }
        } else {
            return null;
        }
    }

    const documentInputValue = () => {
        if (typeDocument !== 'VN' && documentTypeReference) {
            return `NRO. ${documentTypeReference.id} / ${documentTypeReference.boleta_cliente.name} / ${utils.formatMoney(documentTypeReference.monto_total)}`;
        }
        return '';
    }

    return (
        <>
        { isGuide && (modalproducto || confirma) ? <div className="disabled-modal"></div> : null }
        <Row>
           <Col lg={8} style={{ borderRight: '1px dotted #cecece' }}>
           <Row>
                <Col lg={6}>
                 <h3>Recibo de pago</h3>
               </Col>
               <Col lg={3}>
                <div className="grupo-input">
                    <small>Gestor</small>
                    <input type="text" className={`form-control input-border`} name="email_confirm" disabled value={config.username}/>
                </div>
               </Col>
               <Col lg={3}>
                <div className="grupo-input">
                    <small>Fecha Recibo</small>
                    <input type="text" className={`form-control input-border`} name="email_confirm" disabled value={moment().format('DD/MM/YYYY')}/>
                </div>
               </Col>
           </Row>
           {!isGuide ?
           <Row>
               <Col>
                 <DocumentSalesType 
                    onSelectReferenceSale={(item) => setDocumentTypeReference(item)}
                    onSelectedTypeDocument={(type) => setTypeDocument(type)}
                    inputValue={() => documentInputValue()}
                 />
               </Col>
           </Row> 
           : null}
           <Row>
                <Col lg={3}>
                    <small>Rut</small>
                    <div className="d-flex mb-2">
                            <input type="text"
                                className={`form-control input-border`}
                                disabled
                                value={cliente ? cliente.rut : ''}
                            />
                    </div>
                </Col>
                <Col>
                    <small>Cliente</small>
                    <div className="d-flex mb-2">
                            <input type="text"
                                className={`form-control input-border`}
                                disabled
                                value={cliente ? cliente.name.toUpperCase() : ''}
                            />
                            {!isGuide ?
                            <>
                                <button onClick={() => setModalCliente(true)} type="button" className="btnx btnx-warn icon-table">
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                                <button onClick={removercliente} type="button" className="btnx btnx-warn icon-table" style={{ backgroundColor: '#FC2D2D' }}>
                                    <FontAwesomeIcon icon={faEraser} />
                                </button> 
                            </>
                            : null}
                    </div>
                 </Col>
           </Row>
           <Row>
                <Col>
                    <small>Producto</small>
                    <div className="d-flex mb-2">
                            <input type="text"
                                className={`form-control input-border`}
                                disabled
                                value={producto ? producto.nombre_producto.toUpperCase() : ''}
                            />
                            <button onClick={() => setModalProducto(true)} type="button" className="btnx btnx-warn icon-table">
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                    </div>
                 </Col>
                 <Col lg={3}>
                    <small>Cantidad</small>
                    <div className="d-flex mb-2">
                            <input type="text"
                                    className={`form-control input-border`}
                                    onKeyPress={(event) => utils.onlyNumber(event)}
                                    onChange={cantidadproducto}
                                    value={cantidad}
                            />
                             <button onClick={agregarProducto} type="button" className="btnx btnx-warn icon-table ml-2">
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                    </div>
                </Col>
           </Row>
           <Row>
               <Col>
                    <DataTable
                        noHeader={true}
                        customStyles={table.customStyles}
                        columns={table.columns(changePriceColumn, productsInputs, removeItems)}
                        data={data}
                        dense={true}
                        noDataComponent={'No existen productos agregados'}
                    />
                </Col>
           </Row>
           <Row>
               <Col className="d-flex justify-content-start align-items-end m-1">
                    <button type="button" onClick={validarinformacion} className="btnx btnx-warn" style={{ height: 35 }}>
                            <FontAwesomeIcon icon={faMoneyBill} /> Registrar pago
                    </button>
                    {btnClose ? 
                    <button type="button" onClick={onClose} className="btnx btnx-warn ml-2" style={{ height: 35 }}>
                            Cancelar
                    </button>
                    : null }
               </Col>
           </Row>
           <ClienteComponentModal
               onSelected={clienteseleccionado}
               visibleOpen={modalcliente}
               onClose={() => setModalCliente(false)}
           />
           <ProductSearchModal
                backDrop={!isGuide}
                onSelected={productoseleccionado}
                visibleOpen={modalproducto}
                onClose={() => setModalProducto(false)}
                isGuide={isGuide}
                isReserve={isReserved}
           />
           </Col>
           <Col lg={4}>
                <Row>
                    <Col className="d-flex justify-content-start m-1" style={{ borderRight: '1px dotted #cecece' }}>
                        <div className="d-flex align-items-start flex-column">
                            <small>Total Recibido</small>
                            <div className="monto-text amount-good d-flex flex-column w-100" style={{ color: recibido !== subtotal ? '#FC2D2D' : '#68DA61' }}>
                                ${utils.formatMoney(recibido)}
                                {mensajedinerorestante()}
                            </div>
                        </div>
                    </Col>
                    <Col className="d-flex justify-content-end m-1">
                        <div className="d-flex align-items-end flex-column">
                            <small>Total a Pagar</small>
                            <div className="monto-text amount-good">
                                ${utils.formatMoney(subtotal)}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <small>Tipo de pago</small>
                        <div className="d-flex mb-2">
                            <select onChange={(event) => setIndex(event.target.value)} className="form-control">
                                    <option value="null">Seleccione</option>
                                {tipospago.map((item, index) => {
                                    return <option key={item.id} value={index}>{item.description.toUpperCase()}</option>
                                })}
                            </select>
                            <button disabled={data.length ? false : true} onClick={agregarpagos} type="button" className="btnx btnx-warn icon-table ml-2">
                                <FontAwesomeIcon icon={faPlus} />
                            </button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        {pagos.map((item, index) => {
                            return <React.Fragment key={item.uuid}>
                                        <small>Agregue el monto pagado en {item.description}</small>
                                        <div className="d-flex mb-2">
                                            <div className="grupinput-two">
                                                <input
                                                    ref={(el) => pagosInputs.current[item.uuid] = el}
                                                    type="text"
                                                    className={`form-control input-border`}
                                                    placeholder={`Monto a recibido en ${item.description}`}
                                                    onBlur={(event) => agregarmontopagos(event, item, false, 'monto')}
                                                    onKeyPress={(event) => agregarmontopagos(event, item, false, 'monto')}
                                                    defaultValue={item.monto}
                                                />
                                                {item.referencia ? 
                                                    <input
                                                        ref={(el) => pagosInputs.current[item.uuid] = el}
                                                        type="text"
                                                        className={`form-control input-border mt-1`}
                                                        placeholder={`Referencia asociada al pago`}
                                                        onBlur={(event) => agregarmontopagos(event, item, true, 'referencia_pago')}
                                                        onKeyPress={(event) => agregarmontopagos(event, item, true, 'referencia_pago')}
                                                        defaultValue={""}
                                                    />
                                                : null}
                                            </div>
                                                <button onClick={() => removertipopago(item.uuid)} type="button" className="btnx btnx-warn icon-table ml-2">
                                                    <FontAwesomeIcon icon={faTrash} />
                                                </button>
                                        </div>
                                     </React.Fragment>
                        })}
                    </Col>
                </Row>
                <ConfirmaBoleta 
                    show={confirma}
                    onClose={closeCofirmar}
                    onConfirm={(values) => completedataconfirm(values)}
                    monto={subtotal}
                    backDrop={!isGuide}
                />
           </Col>
        </Row>

        <ConfirmAlertV2
          typeBtn="hidden"
          show={confirmSameClient}
          onConfirm={confirmSameClientAction}
          message="Quieres usar el mismo cliente del cliente asociado anterior."
          buttonText="Si, usar el mismo"
          buttonCancel="No"
          onCancel={() => setConfirmSameClient(false)}
        />
    </>
    )
}


export default FacturacionComponent;